import { render, staticRenderFns } from "./ThemeFormListReplicator.vue?vue&type=template&id=13803da7"
import script from "./ThemeFormListReplicator.vue?vue&type=script&lang=js"
export * from "./ThemeFormListReplicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports